import { useRef, useEffect } from 'react';
import { ScrollClasses } from './classes';

export const useScrollDrag = <T extends HTMLElement>(mainScrollId?: string) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref?.current) {
      const slider = ref.current;
      const mainScroll = mainScrollId ? document.getElementById(mainScrollId) : undefined;
      if (mainScroll) {
        if (mainScroll !== slider) {
          slider.scrollLeft = mainScroll.scrollLeft;
        }
      }
    }
  }, [mainScrollId]);

  useEffect(() => {
    const mainScroll = mainScrollId ? document.getElementById(mainScrollId) : undefined;

    let isDown = false;
    let startX: number;
    let scrollLeft: number;

    if (ref?.current) {
      const slider = ref.current;

      const onMouseMove = (e: MouseEvent) => {
        if (isDown) {
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = x - startX;
          slider.scrollLeft = scrollLeft - walk;
        }
      };

      const onMouseDown = (e: MouseEvent) => {
        e.preventDefault();
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.classList.add(ScrollClasses.scrollDrag);
      };

      const onMouseUp = (e: MouseEvent) => {
        if (!isDown) return;
        e.preventDefault();
        isDown = false;
        slider.classList.remove(ScrollClasses.scrollDrag);
      };

      const onScroll = (_e: Event) => {
        if (mainScroll) {
          if (mainScroll !== slider) {
            mainScroll.scrollLeft = slider.scrollLeft;
          }
        }
      };

      const onMainScroll = (element: Element) => {
        slider.scrollLeft = element.scrollLeft;
      };

      if (mainScroll) {
        if (mainScroll !== slider) {
          mainScroll.addEventListener('scroll', () => onMainScroll(mainScroll));
        }
      }
      slider.addEventListener('mousedown', onMouseDown);
      document.addEventListener('mouseup', onMouseUp);
      document.addEventListener('mousemove', onMouseMove);
      slider.addEventListener('scroll', onScroll);
      return () => {
        if (mainScroll) {
          if (mainScroll !== slider) {
            mainScroll.removeEventListener('scroll', () => onMainScroll(mainScroll));
          }
        }
        slider.removeEventListener('mousedown', onMouseDown);
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
        slider.removeEventListener('scroll', onScroll);
      };
    }
  }, [mainScrollId]);

  return { ref };
};
